import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { getStoredBearer, storeBearer } from './api/auth.js';
import { initAdminPostHog } from './lib/posthog.js';
import { initAdminSentry } from './lib/sentry.js';
import './styles/globals.css';

// Init observability BEFORE React mounts so any startup error
// during hydration captures + the first identify() comes through.
// Both no-op when their VITE_* keys are unset.
initAdminSentry();
initAdminPostHog();

// Returning-session identify: storeBearer also fires identify; reuse
// it to identify the existing bearer (no-op localStorage write, but
// the side-effect is what we want).
const existingBearer = getStoredBearer();
if (existingBearer) storeBearer(existingBearer);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
